<template>
    
  <div style="height:100%; overflow: auto;">
   <div class="text-left" style="margin-top: 0px; border-bottom: 1px solid #CCC; margin-left: 0px ; margin-right: 0px; padding:0px;">
    <h2>
      <i style="margin-top: 0px; padding-right:20px" class="fa fa-md fa-thumb-tack" aria-hidden="true"></i>geparkte Calls
        <div class="small pull-right">
          <button class="btn btn-sm" :class="{ 'btn-primary': loadBy == 'user' }" type="button" @click="loadByUserCallCenter" title="Geparkte Calls des Agenten">
            <i class="fa fa-user " aria-hidden="true"></i>
          </button>
          <button   class="btn btn-sm" :class="{ 'btn-primary': loadBy == 'company' }" type="button" @click="loadByCompanyCallCenter" title="Geparkte Calls des Callcenters">
            <i class="fa fa-home " aria-hidden="true"></i>
          </button>
  
        </div>
      
    </h2>
   </div>
    <div class="cc-parking" >
      
       <div class="panel cc-panel-default"  v-for="(parking, index) in parkingCalls">
        
         <div style="margin: 5px" class="media">
          <div class="media-left media-middle text-center">
            <i class="text-center fa fa-lg fa-clock-o" :style="{ color: timeDiffColor(parking.datetimeParking) }" aria-hidden="true"></i>
            <small style="white-space:nowrap;" >{{timeDiff(parking.datetimeParking)}}</small>
          </div>
          <div class="media-body">
            <div>
              <strong>{{getDateTime(parking.datetimeParking)}}</strong>
                - {{parking.nameCaller}} für {{parking.nameClient}}
            </div>
            <div class="cc-msg">
              <small>Agent: {{parking.nameAgent}}</small>
            </div>
          </div>
          <span class="media-right media-middle">
            <button type="button"
                title="Eintrag bearbeiten"
                class="btn  btn-link cc-btn-menue"
                v-on:click="onEdit(parking)">
                <span class="glyphicon glyphicon-eye-open"></span>
            </button>
          </span>

        </div>
    
     </div>
      
     <div style="margin-top: 20px" v-show="!parkingCalls.length" class="alert alert-warning" role="alert">
       <span v-if="isParkingEnabeld">Keine geparkten Calls</span>
       <span v-else>"Parken" ist nicht freigeschaltet!</span>
     </div>

  </div>
</div>
                   
    
</template>



<script>

import bus from './common/bus'
import { PARKING_INTERVAL } from './common/misc.conf.js'
import moment from 'moment'  


export default {
    
  components: {
  },
  
  data () {
    return {
      
      filter: {
          send: false,
          trash: false,
          abort: false,
          parking: false,
          userCaller: false,
      },

      parkingCalls: [],
      limit: 10,
      loadBy: 'user',
      interval: null,
      
    }
  },
  
  created: function () {
    
  },

  mounted: function () {
    // Nach F5 holen wir uns die parking Daten
    if(bus.isLoggedIn() && this.isParkingEnabeld){
      this.startInterval();
    }
  },
 
  beforeDestroy: function () {
    this.stopInterval()
  },

  
  computed: {
    
    filteredparkingCalls: function () {
      
      return this.parkingCalls
        .filter(item => !(item.completion.match("^Abschluss") && this.filter.send) )
        .filter(item => !(item.completion.match("^Papierkorb") && this.filter.trash) )
        .filter(item => !(item.completion.match("^Abbruch") && this.filter.abort) )
        .filter(item => !(item.completion.match("^Parking") && this.filter.parking) )
    },

    isParkingEnabeld: function () {
      return !!(bus.login.companyCallCenter.advancedFeatures.search("parken") != -1)
    },
    
  },
  
  methods: {
    

    timeDiff: function (dateTime) {
      moment.locale('de');
      moment.updateLocale('de', {
      relativeTime : {
          s  : '< 1 Minute',
      }
    });
      
      
      let d = new Date(dateTime);
      
      //this.timeDiffColor(dateTime);
      
      return moment(d).fromNow();
    },

    timeDiffColor: function (dateTime) {
      moment.locale('de');
      let d = moment(new Date(dateTime));
      let diff = moment().diff(d,'minutes');
      
      if(diff < 10 ){
        return 'green';
      }else if(diff < 30 ){
        return 'orange';
      }else{
        return 'red';
      }
      
      console.log(s);
    },

    getDateTime: function (dateTime) {
      moment.locale('de');
      let d = new Date(dateTime);
      let d_now = new Date();
      let dateString = '';
      
      
      if(d.toDateString() == d_now.toDateString()){
        dateString = 'Heute, ' + moment(d).format('HH:mm');
      }else{
        dateString = moment(d).format('dd DD.MM, HH:mm');
      }
        
      
      return dateString;
    },

    onEdit: function (parking) {
        // console.log(parking);
        this.deleteParking(parking)
    },
    

    reset: function () {
      this.parkingCalls = [];
    },
    
    startInterval: function () {
      this.stopInterval()
      // ... and than start
      this.interval = setInterval(this.loadAutomatic, PARKING_INTERVAL);
      this.loadAutomatic();
    },
    
    stopInterval: function () {
      clearInterval(this.interval)
      this.interval = null
    },
    
    
    loadAutomatic: function () {
      console.log('PARKING_INTERVAL: ' + PARKING_INTERVAL);
      if(this.loadBy == 'user'){
        this.loadByUserCallCenter();
      }else if (this.loadBy == 'company'){
        this.loadByCompanyCallCenter();
      }else{

      }
    },

    // Wenn kein Auftraggeber ausgewählt, dann werden die letzten calls des Agenten gezeigt
    loadByUserCallCenter: function () {
      this.loadBy = 'user';
      const query = 'user/callcenter/' + bus.call.idUserCallCenter;
      const options = {params: {limit: this.limit}};
      this.load(query,options);
    },

    loadByCompanyCallCenter: function () {
      this.loadBy = 'company';
      const query = 'company/callcenter/' + bus.call.idCompanyCallCenter;
      const options = {params: {limit: this.limit}};
      this.load(query,options);
    },
    

    load: function (query,options ) {
      this.$http.get(bus.config.path + '/parking/' + query, options).then((response) => {
        this.parkingCalls = response.data;

        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    deleteParking: function (parking ) {
      this.$http.delete(bus.config.path + '/parking/' + parking.id).then((response) => {
        console.log(response.data);
  
        if(response.data){
          this.loadCall(parking.idCall)
        }
        else{
          console.warn("geparkter Eintrag nicht mehr vorhanden!");
        }

      }, (response) => {
      // error callback
      });
    },

    loadCall: function (callId ) {
      this.$http.get(bus.config.path + '/call/' + callId).then((response) => {
        console.log(response.data);
        const call = response.data;
        
        bus.call.id = call.id;
        bus.call.calledNumber = call.calledNumber;
        bus.call.callingNumber = call.callingNumber;
        bus.call.callingNumber = call.callingNumber;
        // Auch beim Parken beginnen wir mit now., da die Parkzeit berechnet werden muss
        bus.call.datetimeBegin = moment().format('YYYY-MM-DD HH:mm:ss');;
        
        bus.emitStopAcdInterval();
        bus.emitIdCompanyClient(call.idCompanyClient);
        bus.emitIdUserClient(call.idUserClient, true);
        bus.emitIdUserCaller(call.idUserCaller);
        bus.emitAddMessage(call.message);
        bus.emitMessageStatus(call.messageStatus);
  
        

      }, (response) => {
      // error callback
      });
    },
    
  }
  
}
</script>



<style scoped>

  
  .cc-panel-default:hover{
     background-color: #fcf8e3;
  }
  
  .cc-msg{
    overflow: hidden;
    white-space: nowrap;
    margin-right: 10px
  }  
  
h2 .fa, .panel .fa {
    padding-right: 2px;
}
  
    .fa-send{
      color: #449d44;      
    }
    
    .fa-trash{
      color: #f0ad4e;       
    }
    .fa-times-circle{
      color: #d9534f;
    }
    
    .fa-thumb-tack{
      color: #337ab7;       
    }
  
  small{
    color: gray;
  }  
  
.panel {
    margin-bottom: 4px;
    border-bottom: 1px solid lightgrey;
}

.panel-title{
  font-size: 14px  ;
}

.cc-parking{
    overflow: auto;
  }
  
  .fa-clock-o{
    width: 100px;
  }  

</style>



// WEBPACK FOOTER //
// Parking.vue?9c2589a2